export default __webpack_public_path__ + "static/media/tree_4.bdcb0cb4.png";